import {confirmPendingChanges} from '../hooks/useUnsavedChanges';
import {getStoredUser} from '../api';
export function preferenceKey(name) { return `dispoboard:${window.location.host}:${getStoredUser()?.username || 'guest'}:${name}`; }
export function readPreference(name, fallback) { try { return JSON.parse(localStorage.getItem(preferenceKey(name))) ?? fallback; } catch { return fallback; } }
export function writePreference(name, value) { try { localStorage.setItem(preferenceKey(name), JSON.stringify(value)); } catch {} }
export async function openPlanning(job, page = 'planner') {
 if(!await confirmPendingChanges())return false;
 const url = new URL(window.location.href); url.hash = page; url.searchParams.set('job', job.id);
 if (job.dispo_start) url.searchParams.set('at', job.dispo_start);
 url.searchParams.delete('q'); url.searchParams.delete('status');
 window.history.pushState(null, '', url); window.dispatchEvent(new PopStateEvent('popstate',{state:{workspaceConfirmed:true}}));return true;
}
